import { Col, Form, Input, Radio, Row, AutoComplete, Button, InputNumber } from 'antd'
import { useCallback, useEffect, useState } from 'react'
import { orderService, productService, customerService } from 'services'
import styled from 'styled-components'
import { numberWithCommas } from 'utils'
import { NumericFormat } from 'react-number-format'
import { InfoCircleFilled } from '@ant-design/icons'
import ModalInfo from './ModalInfo'

const BoxSelectPackage = styled.div`
  position: relative;

  label {
    text-wrap: wrap !important;
  }
`
const BoxSearchProduct = styled.div`
  position: relative;
  .ant-select-selector  {
    padding: 0 !important;
  }
  .input-search-product {
    input {
    height: 40px !important;}
  }
`
const SavePackage = styled.div`
  position: relative;
    .action-save{
      position: absolute;
      top:8px;
      right:30px;
      color:red;
      cursor:pointer
  }
    .action-save:hover{color: orange}
`

const OrderDetailForm = ({
  form,
  setPackageSelected,
  packageSelected,
  setQty,
  customerProfile,
  packageList,
  setPackageList,
  setProductPriceDefault,
  dataDetail,
  orderPriceDefault,
  transporterId,
  usedPackage
}) => {
  const [hasAmountCollected, setHasAmountCollected] = useState<boolean>(true)
  const [amountCollected, setAmountCollected] = useState<number>(0)
  const [defaultOrderPrice, setDefaultOrderPrice] = useState<number | string>(0)
  const [options, setOptions] = useState([]);
  const [typePackageDesc, setTypePackageDesc] = useState<string>('')
  const [openModalInfo, setOpenModalInfo] = useState<boolean>(false)
  const [transporters, setTransporters] = useState<any[]>([])
  const [transportersDefault, setTransportersDefault] = useState<any>()
  const [transporterSelected, setTransporterSelected] = useState<any>()
  const [packageListShow, setPackageListShow] = useState<any[]>([])
  const [defaultPackage, setDefaultPackage] = useState(0)

  useEffect(() => {
    orderService.getTransporter((data) => {
      setTransporters(data?.data?.transporters)
    })
  }, [setTransporters])

  useEffect(() => {
    if(packageList && transporterId){
      setDefaultOrderPrice(orderPriceDefault);
      setTransporterSelected(transporterId);
      setTimeout(function(){
        onChangePackage(usedPackage?.id)
        setHasAmountCollected(form.getFieldValue('transferFee'));
      },500);
    }
  }, [orderPriceDefault,transporterId,packageList])

  useEffect(() => {
    orderService.getPackageList((data) => {
      setPackageList(data?.data?.packages)
    })
  }, [setPackageList])

  useEffect(() => {
    if (transporterSelected) {
      setPackageListShow(packageList?.filter((item) => +item?.transporter_id === +transporterSelected))
    }
  }, [packageList, transporterSelected])

  const handleChagnePrice = useCallback(() => {
    const selectedPackage = packageList.find((item) => +item?.id === +form.getFieldValue('typePackage'))
    const price = form.getFieldValue('orderPrice') || 0
    const qty = form.getFieldValue('orderQty') || 0
    setAmountCollected((selectedPackage?.fee || 0) * +qty + +price)
    setQty(+qty)
  }, [form, packageList, setQty])

  const handleSelectProduct = useCallback((value) => {
    const data: any = options.find((item: any) => item?.value === value)
    
    if (data) {
      const packageItem = packageList.find((item) => +item?.weight >= +data?.weight && item.transporter_id == transporterSelected);
      if (packageItem) {
        setTypePackageDesc(packageItem.sumary)
        setPackageSelected(packageItem)
        form.setFieldValue('typePackage', +packageItem?.id)
      }
      form.setFieldValue('orderPrice', data?.price)
      form.setFieldValue('productPrice', data?.product_price)

      setDefaultOrderPrice(data?.price)
      setProductPriceDefault(data?.product_price)
      handleChagnePrice()
    }

  }, [options, form, setDefaultOrderPrice, packageList])

  const handleSearchProduct = useCallback(() => {
    productService.getList({ page: 1, per_page: 100 }, (data) => {
      setOptions(data?.data?.products?.map((item) => ({
        value: item?.title, id: item?.id, price: item?.price
        , product_price: item?.product_price, weight: item?.weight
      })))
    })
    return
  }, [form])

  const handleAutoCompleteProduct = useCallback(() => {
    const value = form.getFieldValue('orderName')
    if (value.length < 3) {
      setOptions([])
      return;
    }
    productService.getList({ page: 1, per_page: 100, title: value }, (data) => {
      setOptions(data?.data?.products?.map((item) => ({
        value: item?.title, id: item?.id,
        product_price: item?.product_price,
        price: item?.price, weight: item?.weight
      })))
    })
    return
  }, [form])

  const onChangePackage = useCallback(
    (packageId) => {
      setTypePackageDesc(packageList.find((item) => +item?.id === +packageId)?.sumary)
      setPackageSelected(packageList.find((item) => +item?.id === +packageId))
      form.setFieldValue('typePackage', +packageId);
      handleChagnePrice()
    },
    [form, handleChagnePrice, packageList, setPackageSelected]
  )
  const onSavePackage = () =>{
    if(defaultPackage !== packageSelected?.id){
      setDefaultPackage(packageSelected?.id);
      const name = packageSelected?.title + ' - ' + numberWithCommas(packageSelected?.fee) + 'đ (kích thước: '
        + packageSelected?.length + 'x' + packageSelected?.width + 'x' + packageSelected?.height + 'cm)';
      const account = packageSelected?.transporter?.title;
      const payload = {
        id: packageSelected?.id,
        name: name,
        account: account
      }
      customerService.setDefaultPackage(payload,() => {
        console.log('Ok');
      });
    }
  }

  useEffect(() => {
    if (customerProfile?.default_package_id) {
      onChangePackage(customerProfile?.default_package_id)
      if(!transporterId){
        setTransportersDefault(packageList.find((item) => +item?.id === +customerProfile?.default_package_id)?.transporter_id)
        setTransporterSelected(packageList.find((item) => +item?.id === +customerProfile?.default_package_id)?.transporter_id)
      }
      if(!defaultPackage){
        setDefaultPackage(customerProfile?.default_package_id)
      }
    }
  }, [customerProfile?.default_package_id, onChangePackage, packageList])

  useEffect(() => {
    if (transporterSelected !== transportersDefault) {
      onChangePackage(packageListShow?.[0]?.id)
    } else {
      onChangePackage(customerProfile?.default_package_id)
    }
  }, [customerProfile?.default_package_id, onChangePackage, packageListShow, transporterSelected, transportersDefault])

  return (
    <>
      <Form
        form={form}
        layout='horizontal'
        labelCol={{ span: 5, md: { span: 4 }, lg: { span: 4 }, xxl: { span: 3 } }}
        wrapperCol={{ span: 20, lg: { span: 20 }, xxl: { span: 21 } }}
      >
        <Row gutter={[24, 0]}>
          <Col span={24}>
            <BoxSearchProduct>
              <Form.Item
                label='Tên sản phẩm'
                name='orderName'
                rules={[{ required: true, message: 'Vui lòng nhập Tên sản phẩm' }]}
              >
                <AutoComplete options={options} onChange={handleAutoCompleteProduct} onSelect={handleSelectProduct}>
                  <Input.Search
                    placeholder='Nhập Tên sản phẩm'
                    className='input-search-product'
                    size='large'
                    enterButton={<Button onClick={handleSearchProduct}>Sản phẩm</Button>}
                  />
                </AutoComplete>
              </Form.Item>
            </BoxSearchProduct>
          </Col>
          <Col span={24}>
            <Form.Item label='Cho xem hàng' name='isCheck'>
              <Radio.Group defaultValue={1}>
                <Radio value={1}>Có</Radio>
                <Radio value={0}>Không</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item label='Gói vận chuyển'>
              <Radio.Group
                value={transporterSelected}
                onChange={(e) => {
                  setTransporterSelected(e?.target?.value)
                }}
              >
                {transporters?.map((item) => (
                  <Radio key={item?.id} value={item?.id}>
                    {item?.title}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>

            <BoxSelectPackage>
              <SavePackage>
                <Form.Item label={<div />} colon={false} name='typePackage'>
                  <select
                    className='custom-select'
                    disabled={!!dataDetail}
                    onChange={(e) => {
                      onChangePackage(e?.target?.value)
                    }}
                  >
                    <option value=''>Chọn gói</option>
                    {packageListShow?.map((item) => (
                      <option value={item?.id} key={item?.id} selected={usedPackage?.id === item?.id}>
                        {item.title} - {numberWithCommas(item.fee)}đ (kích thước: {item?.length}x{item?.width}x{item?.height}cm)
                      </option>
                    ))}
                  </select>
                </Form.Item>
                <span className='action-save' onClick={onSavePackage}>Gắn mặc định</span>
              </SavePackage>
              {typePackageDesc && (
                <Row>
                  <Col
                    span={24}
                    sm={{ span: 19, push: 5 }}
                    md={{ span: 20, push: 4 }}
                    lg={{ span: 20, push: 4 }}
                    xxl={{ span: 21, push: 3 }}
                    push={0}
                  >
                    <p>
                      <InfoCircleFilled style={{ color: '#008848', cursor: 'pointer' }} onClick={() => setOpenModalInfo(true)} />{' '}
                      {typePackageDesc}
                    </p>
                  </Col>
                </Row>
              )}
            </BoxSelectPackage>
          </Col>

          <Col span={24}>
            <Form.Item label='Phí vận chuyển' name='transferFee'>
              <Radio.Group
                defaultValue={1}
                onChange={(e) => {
                  setHasAmountCollected(Boolean(e?.target?.value))
                  handleChagnePrice()
                }}
              >
                <Radio value={0}>Người gửi trả</Radio>
                <Radio value={1}>Người nhận trả</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item style={{ display: 'none' }} name='orderPrice' />
            <Form.Item label='Tiền hàng'>
              <NumericFormat
                className='number-format'
                allowLeadingZeros
                thousandSeparator=','
                value={defaultOrderPrice}
                onValueChange={(e) => {
                  form.setFieldValue('orderPrice', e?.floatValue)
                  handleChagnePrice()
                }}
                onFocus={(e) => {
                  if (e?.target?.value == '0') {
                    setDefaultOrderPrice('')
                  }
                }}
                onBlur={(e) => {
                  if (e?.target?.value == '') {
                    setDefaultOrderPrice(0)
                  }
                }}
                isAllowed={(values: any) => {
                  const { floatValue } = values
                  if (floatValue) {
                    return floatValue <= 999999999999
                  }
                  return true
                }}
                placeholder='Nhập tiền hàng'
                defaultValue={defaultOrderPrice}
              />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label='Số kiện hàng' name='orderQty' rules={[{ required: true, message: 'Vui lòng nhập Số kiện hàng' }]}>
              <InputNumber placeholder='Nhập Số kiện hàng' onChange={handleChagnePrice} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item label='Tiền thu hộ'>
              <Input
                placeholder='Nhập Tiền thu hộ'
                disabled
                value={numberWithCommas(hasAmountCollected ? amountCollected : +form.getFieldValue('orderPrice'))}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <ModalInfo open={openModalInfo} onCancel={() => setOpenModalInfo(false)} packageSelected={packageSelected} />
    </>
  )
}

export default OrderDetailForm
